class Base64Service {
  static readonly decode = (base64String: string): string => decodeURIComponent(window.atob(base64String.replace(/-/g, '+').replace(/_/g, '/')));
}

export default Base64Service